import React from "react";
import "./BrandCategorizationStyles.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "@mui/material/Button";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Menu, MenuItem } from "@mui/material";
import edit from "../../../assests/edit.svg";
import emotions7 from "../../../assests/emotions7.svg";
import LoadingSpinner from "../../Loading/component";

const BrandCategorizationComponent = (props) => {
  const navigate = useNavigate();
  const handleClick = () => navigate("/");

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="brand-categorization-container">
          <div >
            <Sidebar />
          </div>

          <div className="brand-categorization-content">
            <div className="brand-categorization-header">
              <h2 className="brand-categorization-title">
                <img
                  onClick={handleClick}
                  className="brand-categorization-back-icon"
                  src={leftArrow}
                  alt="Back"
                />{" "}
                Brand Categorization
              </h2>
            </div>
            
            <div className="brand-categorization-filter-container">
              <Button
                variant="contained"
                color="primary"
                startIcon={<FilterListIcon />}
                onClick={props.handleClick}
                className="brand-categorization-filter-button"
              >
                {props.buttonLabel ||
                  (props.warehouseData.length > 0
                    ? props.warehouseData[0].warehouseName
                    : "Filter")}
              </Button>

              <Menu
                className="brand-categorization-filter-menu"
                anchorEl={props.anchorEl}
                open={Boolean(props.anchorEl)}
                onClose={props.handleClose}
              >
                {props.warehouseData.map((warehouse) => (
                  <MenuItem
                    key={warehouse.warehouseId}
                    onClick={() =>
                      props.handleOptionClick(
                        warehouse.warehouseId,
                        warehouse.warehouseName
                      )
                    }
                  >
                    {warehouse.warehouseName}
                  </MenuItem>
                ))}
              </Menu>
            </div>
            
            <div className="brand-categorization-table-container">
              <div
                ref={props.tableContainerRef}
                className="brand-categorization-table-wrapper"
              >
                <Table striped responsive className="brand-categorization-table">
                  <thead>
                    <tr>
                      <th>Brands</th>
                      <th className="brand-categorization-table-column">Last 3 month Sales</th>
                      <th className="brand-categorization-table-column">Onboarded time</th>
                      <th className="brand-categorization-table-column">VM Count</th>
                      <th>Category</th>
                      <th>Billing Cycle</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.categoryData && props.categoryData.length > 0 ? (
                      props.categoryData.map((item, index) => {
                        const isEditable = props.editableRow === index;
                        const uppercaseBrandCategory = item.brandCategory
                          ? item.brandCategory.toUpperCase()
                          : "";
                        const isSTDChecked = props.selectedCheckboxes.includes("std");
                        const isGMPChecked = props.selectedCheckboxes.includes("gmp");
                        const isMPChecked = props.selectedCheckboxes.includes("mp");

                        return (
                          <tr key={index} className="brand-categorization-view">
                            <td>{item.displayName}</td>
                            <td className="brand-categorization-table-column">{item.last3MonthSales}</td>
                            <td className="brand-categorization-table-column">{item.onboardedTime}</td>
                            <td className="brand-categorization-table-column">{item.vmCount}</td>
                            <td>
                              {isEditable ? (
                                <div className="brand-categorization-category-options">
                                  <label className="brand-categorization-category-option std-option">
                                    <input
                                      type="checkbox"
                                      value="std"
                                      checked={isSTDChecked}
                                      onChange={(e) => props.handleCheckboxChange(e, "std")}
                                    />
                                    <span>STD</span>
                                  </label>
                                  <label className="brand-categorization-category-option gmp-option">
                                    <input
                                      type="checkbox"
                                      value="gmp"
                                      checked={isGMPChecked}
                                      onChange={(e) => props.handleCheckboxChange(e, "gmp")}
                                    />
                                    <span>GMP</span>
                                  </label>
                                  <label className="brand-categorization-category-option mp-option">
                                    <input
                                      type="checkbox"
                                      value="mp"
                                      checked={isMPChecked}
                                      onChange={(e) => props.handleCheckboxChange(e, "mp")}
                                    />
                                    <span>MP</span>
                                  </label>
                                </div>
                              ) : (
                                <span className={`brand-categorization-category-tag ${item.brandCategory?.toLowerCase()}-tag`}>
                                  {uppercaseBrandCategory}
                                </span>
                              )}
                            </td>
                            <td>
                              {isEditable ? (
                                <input
                                  className="brand-categorization-billing-input"
                                  type="number"
                                  value={item.billingCycle}
                                  onChange={(e) => props.handleInputChange(e, index)}
                                />
                              ) : (
                                `${item.billingCycle} Days`
                              )}
                            </td>
                            <td className="brand-categorization-action-cell">
                              {isEditable ? (
                                <button
                                  className="brand-categorization-update-button"
                                  onClick={props.handleSaveClick}
                                >
                                  update
                                </button>
                              ) : (
                                <img
                                  src={edit}
                                  alt="Edit"
                                  className="brand-categorization-eye-icon"
                                  onClick={() => props.handleEditClick(index)}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7">
                          <div className="brand-categorization-empty-state">
                            <img src={emotions7} alt="No brands found" />
                            <p>No Brand Found</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BrandCategorizationComponent;